<template>
  <div class="flex flex-col">
    <div class="grid grid-cols-12 gap-4">
      <AppModal v-model="showAddReason" title="Add Winding Up Reason">
        <new-reason />
      </AppModal>
      <AppModal v-model="showEditReason" title="Update Winding Up Reason">
        <edit-reason v-if="draft" :draft-data="draft" />
      </AppModal>
    </div>

    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-12">
        <div class="flex items-center gap-2 justify-end mb-4">
          <button
            @click="openForm"
            class="btn-primary"
          >
            <i class="fa-solid fa-plus"></i>
            <span>Add Reason</span>
          </button>
        </div>

        <div class="bg-white rounded border border-gray-200 overflow-hidden">
          <div class="overflow-x-auto">
            <table class="w-full text-xs">
              <thead class="bg-gray-50 sticky top-0">
                <tr>
                  <th class="text-left py-3 px-4 font-semibold text-gray-700 border-b border-gray-200 w-16">#</th>
                  <th class="text-left py-3 px-4 font-semibold text-gray-700 border-b border-gray-200">Name</th>
                  <th class="text-center py-3 px-4 font-semibold text-gray-700 border-b border-gray-200 w-32">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(pb, idx) in professionalBodies"
                  :key="pb.id"
                  class="hover:bg-gray-50 transition"
                >
                  <td class="py-3 px-4 border-b border-gray-200">{{ idx + 1 }}</td>
                  <td class="py-3 px-4 border-b border-gray-200 capitalize font-medium">{{ pb.reason }}</td>
                  <td class="py-3 px-4 border-b border-gray-200">
                    <div class="flex items-center justify-center gap-2">
                      <button
                        @click="openEditForm(pb)"
                        class="btn-sm-primary"
                      >
                        <i class="fa-solid fa-pencil"></i>
                        <span>Edit</span>
                      </button>
                      <button
                        class="btn-sm-danger"
                      >
                        <i class="fa-solid fa-trash"></i>
                        <span>Delete</span>
                      </button>
                    </div>
                  </td>
                </tr>
                <tr v-if="professionalBodies.length === 0">
                  <td colspan="3" class="py-8 px-4 text-center text-gray-500">
                    No reasons found. Click "Add Reason" to create one.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import { useConfigurationsStore } from "../../../../stores";
import AppModal from "@/components/ui/AppModal.vue";
import NewReason from "@/domains/home/services/configurations/views/settings/insolvency/reasons/NewReason.vue";
import EditReason from "@/domains/home/services/configurations/views/settings/insolvency/reasons/EditReason.vue";

interface Reason {
  id: string
  reason: string
}

const store = useConfigurationsStore();
const showAddReason = ref(false)
const showEditReason = ref(false)
const professionalBodies = ref<Reason[]>([])
const draft = ref<Reason | undefined>()

const openForm = () => {
  showAddReason.value = true
}

const openEditForm = (body: Reason) => {
  draft.value = body
  showEditReason.value = true
}

const fetchData = () => {
  store.fetchReasons();
}

onMounted(() => {
  fetchData()
})

watch(
  () => store.insolvencyReasons,
  (data) => {
    if (data) {
      professionalBodies.value = data
    }
  }
)
</script>
